import Vue from 'vue'
import Vuex from 'vuex'
import account from './modules/account'
import setting from './modules/setting'
import driverPositionDate from './modules/driverPosition'
import constants from './modules/constants'

Vue.use(Vuex)

export default new Vuex.Store({
  //modules文件夹用来将不同功能页面的状态分成模块
  modules: {
    //用户帐户信息模块
    account,
    //系统设置模块
    setting,
    //司机位置监控数据
    driverPositionDate,
    //全局常量
    constants,
  },
  getters:{
    permissions:state=>state.account.permissions,
    user:state=>state.account.user,
    dpd:state=>state.driverPositionDate.dpd,
    getOrderExport:state=>state.constants.inTheOrderExport

  }
})



// WEBPACK FOOTER //
// ./src/store/index.js